export default [
  {
    header: 'Services',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'SBP',
        route: 'services-sbp',
      },
      {
        title: 'Property Rates',
        route: { name: 'misc-coming-soon' },
      },
    ],
  },
]
